// Provides CASL ability context based on authenticated user
import { createContext, useContext, useMemo } from 'react';
import { buildAbilityFromUser } from './ability';
import { useAuthStore } from '@stores/auth.store';

let AbilityContext;
if (typeof window !== 'undefined' && import.meta.env.DEV) {
    if (!window.__AbilityContext) {
        window.__AbilityContext = createContext(null);
    }
    AbilityContext = window.__AbilityContext;
} else {
    AbilityContext = createContext(null);
}

const AbilityProvider = ({ children }) => {
    const user = useAuthStore((state) => state.user);
    const ability = useMemo(() => buildAbilityFromUser(user), [user]);

    return (
        <AbilityContext.Provider value={ability}>
            {children}
        </AbilityContext.Provider>
    );
};

export default AbilityProvider;
export const useAbility = () => {
    const context = useContext(AbilityContext);
    if (!context) {
        throw new Error('useAbility must be used within AbilityProvider');
    }
    return context;
};
